module.exports = __webpack_public_path__ + "img/graph-eight-min.86f39d6b.png";